import { TrendingUp } from "lucide-react";
import { CASES } from "@/data";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function Showcase() {
  return (
    <section id="work" data-testid="showcase-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute top-1/3 left-0 w-[24rem] h-[24rem] rounded-full bg-[#2C4A73]/40 blur-[130px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading id="work" overline="Selected Work" title="Proof, not promises" />
        <div className="grid md:grid-cols-3 gap-6">
          {CASES.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.1} className="h-full">
              <div
                data-testid={`card-case-${c.id}`}
                className="group h-full rounded-2xl border border-white/10 bg-[#101F38]/60 overflow-hidden hover:border-[#D9A441]/50 transition-all duration-500 hover:scale-[1.02]"
              >
                <div className="overflow-hidden h-48">
                  <img
                    src={c.image}
                    alt={c.title}
                    data-testid={`case-image-${c.id}`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <span className="text-xs font-mono uppercase tracking-widest text-[#D9A441] border border-[#D9A441]/30 rounded-full px-3 py-1 bg-[#D9A441]/5">
                    {c.category}
                  </span>
                  <h3 className="mt-4 font-display text-xl font-semibold text-[#F3EFE6]">{c.title}</h3>
                  <p className="mt-2 text-sm text-[#9DAEC4] leading-relaxed">{c.desc}</p>
                  <p className="mt-4 flex items-center gap-2 font-mono text-sm text-emerald-400" data-testid={`case-metric-${c.id}`}>
                    <TrendingUp size={15} />
                    {c.metric}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-8 text-xs font-mono text-[#5B6B7E]" data-testid="showcase-note">
            * Sample presentation — swap in your real project screenshots anytime.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
